export const CONTACT_CSS = `
  .cp-page {
    background: var(--color-white);
    min-height: 100vh;
  }

  /* ── Hero banner (compact) ── */
  .cp-hero {
    position: relative;
    height: 38vh; min-height: 280px;
    display: flex; align-items: flex-end;
    overflow: hidden;
    background: var(--color-midnight);
  }
  .cp-hero__bg {
    position: absolute; inset: 0;
  }
  .cp-hero__bg img {
    width: 100%; height: 100%;
    object-fit: cover; display: block;
    opacity: 0.45;
  }
  .cp-hero__overlay {
    position: absolute; inset: 0;
    background: linear-gradient(
      to top,
      rgba(7,30,48,0.8) 0%,
      rgba(7,30,48,0.2)  20%,
      transparent 100%
    );
  }
  .cp-hero__content {
    position: relative; z-index: 2;
    padding: 0 6vw 48px;
    max-width: 1200px; width: 100%;
  }
  .cp-hero__eyebrow {
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.18em; text-transform: uppercase;
    color: var(--color-gold);
    display: block; margin-bottom: 10px;
  }
  .cp-hero__title {
    font-family: var(--font-serif);
    font-size: clamp(2rem, 5vw, 3.6rem);
    font-weight: 300;
    color: var(--color-ivory);
    margin: 0;
    line-height: 1.1;
  }

  /* ── Main layout ── */
  .cp-main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1.5vw;
  }

  /* ── Body: 2 cột ── */
  .cp-body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0;
    border-top: 1px solid var(--color-divider);
  }
  @media (max-width: 860px) {
    .cp-body { grid-template-columns: 1fr; }
  }

  /* ── Left col: info + map ── */
  .cp-info {
    padding: 56px 48px 56px 0;
    border-right: 1px solid var(--color-divider);
    display: flex; flex-direction: column; gap: 40px;
  }
  @media (max-width: 860px) {
    .cp-info {
      padding: 40px 0;
      border-right: none;
      border-bottom: 1px solid var(--color-divider);
    }
  }

  .cp-info__lead {
    font-family: var(--font-serif);
    font-size: 1.15rem; line-height: 1.8;
    color: var(--color-charcoal);
  }

  .cp-details {
    display: flex; flex-direction: column; gap: 20px;
  }
  .cp-detail {
    display: flex; gap: 16px; align-items: flex-start;
  }
  .cp-detail__icon {
    width: 36px; height: 36px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    border: 1px solid var(--color-divider);
    color: var(--color-teal);
  }
  .cp-detail__content {
    display: flex; flex-direction: column; gap: 2px;
  }
  .cp-detail__label {
    font-family: var(--font-sans);
    font-size: 9px; font-weight: 500;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--color-slate);
  }
  .cp-detail__value {
    font-family: var(--font-sans);
    font-size: 14px; line-height: 1.5;
    color: var(--color-charcoal);
  }
  .cp-detail__value a {
    color: var(--color-charcoal);
    text-decoration: none;
    transition: color 0.2s;
  }
  .cp-detail__value a:hover { color: var(--color-teal); }

  /* Social links */
  .cp-socials {
    display: flex; gap: 10px;
  }
  .cp-social {
    width: 36px; height: 36px;
    display: flex; align-items: center; justify-content: center;
    border: 1px solid var(--color-divider);
    color: var(--color-slate);
    text-decoration: none;
    transition: border-color 0.2s, color 0.2s, background 0.2s;
  }
  .cp-social:hover {
    border-color: var(--color-teal);
    color: var(--color-teal);
  }

  /* Google Map embed */
  .cp-map {
    border: 1px solid var(--color-divider);
    overflow: hidden;
    position: relative;
  }
  .cp-map iframe {
    width: 100%; height: 260px;
    display: block; border: none;
  }
  .cp-map__placeholder {
    height: 260px;
    background: var(--color-ivory);
    display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 10px;
    color: var(--color-slate);
    font-size: 12px; letter-spacing: 0.05em;
  }
  .cp-map__placeholder svg { opacity: 0.3; }

  /* ── Right col: form ── */
  .cp-form-col {
    padding: 56px 0 56px 48px;
    display: flex; flex-direction: column;
  }
  @media (max-width: 860px) {
    .cp-form-col { padding: 40px 0 0; }
  }

  .cp-form-col__heading {
    font-family: var(--font-serif);
    font-size: clamp(1.6rem, 2.5vw, 2.2rem);
    font-weight: 300;
    color: var(--color-dark);
    margin-bottom: 6px;
  }
  .cp-form-col__sub {
    font-family: var(--font-sans);
    font-size: 13px; line-height: 1.6;
    color: var(--color-slate);
    margin-bottom: 32px;
  }

  /* Shortcode form container — WPForms / CF7 styles override */
  .cp-form-wrap .wpcf7-form,
  .cp-form-wrap .wpforms-form {
    display: flex; flex-direction: column; gap: 16px;
  }
  .cp-form-wrap input[type="text"],
  .cp-form-wrap input[type="email"],
  .cp-form-wrap input[type="tel"],
  .cp-form-wrap textarea,
  .cp-form-wrap select {
    width: 100%;
    font-family: var(--font-sans);
    font-size: 14px;
    color: var(--color-charcoal);
    background: var(--color-white);
    border: 1px solid var(--color-divider);
    padding: 12px 16px;
    outline: none;
    border-radius: 0;
    transition: border-color 0.2s;
    appearance: none;
  }
  .cp-form-wrap input:focus,
  .cp-form-wrap textarea:focus,
  .cp-form-wrap select:focus {
    border-color: var(--color-teal);
  }
  .cp-form-wrap textarea { min-height: 120px; resize: vertical; }
  .cp-form-wrap input[type="submit"],
  .cp-form-wrap button[type="submit"] {
    font-family: var(--font-sans);
    font-size: 11px; font-weight: 500;
    letter-spacing: 0.12em; text-transform: uppercase;
    background: var(--color-teal);
    color: var(--color-white);
    border: none; padding: 14px 32px;
    cursor: pointer;
    transition: background 0.2s;
    align-self: flex-start;
  }
  .cp-form-wrap input[type="submit"]:hover,
  .cp-form-wrap button[type="submit"]:hover {
    background: var(--color-teal-light);
  }

  /* Mock form (khi chưa có shortcode) */
  .cp-mock-form {
    display: flex; flex-direction: column; gap: 16px;
  }
  .cp-mock-form__row {
    display: grid; grid-template-columns: 1fr 1fr; gap: 12px;
  }
  @media (max-width: 540px) { .cp-mock-form__row { grid-template-columns: 1fr; } }

  .cp-mock-input {
    width: 100%;
    font-family: var(--font-sans); font-size: 14px;
    color: var(--color-charcoal);
    background: var(--color-white);
    border: 1px solid var(--color-divider);
    padding: 12px 16px;
    outline: none;
    transition: border-color 0.2s;
  }
  .cp-mock-input:focus { border-color: var(--color-teal); }
  .cp-mock-input--textarea { min-height: 120px; resize: vertical; }

  .cp-mock-submit {
    font-family: var(--font-sans);
    font-size: 11px; font-weight: 500;
    letter-spacing: 0.12em; text-transform: uppercase;
    background: var(--color-teal); color: var(--color-white);
    border: none; padding: 14px 32px;
    cursor: pointer; align-self: flex-start;
    transition: background 0.2s;
    display: inline-flex; align-items: center; gap: 10px;
  }
  .cp-mock-submit:hover { background: var(--color-teal-light); }

  /* ── Office hours strip ── */
  .cp-hours {
    border-top: 1px solid var(--color-divider);
    padding: 32px 0;
  }
  .cp-hours__inner {
    display: flex; flex-wrap: wrap; gap: 32px;
    align-items: center;
  }
  .cp-hours__label {
    font-family: var(--font-sans);
    font-size: 10px; font-weight: 500;
    letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--color-slate);
    min-width: 100px;
  }
  .cp-hours__items {
    display: flex; flex-wrap: wrap; gap: 24px;
  }
  .cp-hours__item {
    display: flex; flex-direction: column; gap: 2px;
  }
  .cp-hours__day {
    font-size: 10px; letter-spacing: 0.08em; text-transform: uppercase;
    color: var(--color-slate);
  }
  .cp-hours__time {
    font-family: var(--font-serif);
    font-size: 1.05rem;
    color: var(--color-charcoal);
  }

  /* ── Contact Form 7 ── */
  .wpcf7-response-output {
    margin: 10px 0 !important;
  }
`
